import { Injectable, Injector } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ApiFailureDialogComponent } from './api-failure-dialog.component';
import { CmsService } from '@spartacus/core';
import { take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiFailureDialogService {
  apiFailurePopupData: any;

  constructor(private dialog: MatDialog,private injector: Injector) {
    
   }
  
  openErrorDialog(): void {
    const cmsService = this.injector.get(CmsService);
    cmsService.getComponentData('apiFailurePopupComponent').pipe(take(1)).subscribe((data: any)=>{
    this.dialog.open(ApiFailureDialogComponent, {
      disableClose: true,
      data:data
    });
  });
  }
}
